module.exports = __webpack_public_path__ + "img/4.99d5309a.png";